import Browser from '@wetransfer/concorde-browser';

import { isLoggedInFreeUser } from './user';

import Router from '@module/router';

export const openProgressPanel = () => {
  Router.navigateTo('/transfer/progress', Router.SILENT);
};

export const shouldDisplayUpsellProgressPanel = (user) => {
  return !Browser.isMobile && (!user.loggedIn || isLoggedInFreeUser(user));
};
